import json_156910000 from './json/156910000.json';
import json_156920000 from './json/156920000.json';
import json_156930000 from './json/156930000.json';
import json_156940000 from './json/156940000.json';
import json_156950000 from './json/156950000.json';
import json_156960000 from './json/156960000.json';
import json_156970000 from './json/156970000.json';
import json_156980000 from './json/156980000.json';
import json_156990000 from './json/156990000.json';
import json_156991000 from './json/156991000.json';
import json_156992000 from './json/156992000.json';
import json_156993000 from './json/156993000.json';
import json_hainan from './json/156460000.json'

// 以上import的顺序和下方AREA_LIST的顺序相同，对应区域的geojson

// code和json文件的map关系，用于地图业务中根据不同区域，取对应的geojson，然后根据地图geojson文件的配置规则，渲染对应区域
const AREA_JSON_MAP = {
  '156910000': json_156910000,
  '156920000': json_156920000,
  '156930000': json_156930000,
  '156940000': json_156940000,
  '156950000': json_156950000,
  '156960000': json_156960000,
  '156970000': json_156970000,
  '156980000': json_156980000,
  '156990000': json_156990000,
  '156991000': json_156991000,
  '156992000': json_156992000,
  '156993000': json_156993000,
}
// 海南特殊处理
const HAI_NAN_JSON = json_hainan
// 为方便双碳业务逻辑使用，定于的区域数据
const AREA_LIST = [
  {
    name: '中联水泥', // 区域名称
    provinceList: ['山东省', '江苏省', '安徽省', '河北省', '内蒙古自治区'], // 区域所含省、自治区名称
    provinceCodeList: ['156370000', '156320000', '156340000', '156130000', '156150000'], // 区域所含省、自治区对应code
    pcode: '156100000', // 地图下钻所需父层级code，原下钻业务必须，已弃用
    code: '156910000', // 当前区域code，自行定义的数字
    cp: [116.900497, 36.660160], // 当前区域中心点
    distance: 130 // 当前区域渲染距离，因为不同区域的大小各不相同，为解决部分区域有边边角角被渲染到地图组件框外，对不同区域设置不同距离
  },
  {
    name: '北方水泥', // 区域名称
    provinceList: ['内蒙古自治区', '吉林省', '辽宁省', '黑龙江省'], // 区域所含省、自治区名称
    provinceCodeList: ['156150000', '156220000', '156210000', '156230000' ], // 区域所含省、自治区对应code
    pcode: '156100000', // 地图下钻所需父层级code，原下钻业务必须，已弃用
    code: '156993000', // 当前区域code，自行定义的数字
    cp: [125.300762,43.826263], // 当前区域中心点
    distance: 110 // 当前区域渲染距离，因为不同区域的大小各不相同，为解决部分区域有边边角角被渲染到地图组件框外，对不同区域设置不同距离
  },
  {
    name: '中联同力',
    provinceList: ['河南省', '河北省', '山西省'],
    provinceCodeList: ['156410000', '156130000', '156140000'],
    pcode: '156100000',
    code: '156920000',
    cp: [113.736961, 34.791847],
    distance: 180
  },
  {
    name: '南方水泥',
    provinceList: ['江苏省', '上海市', '安徽省', '浙江省'],
    provinceCodeList: ['156320000', '156310000', '156340000', '156330000'],
    pcode: '156100000',
    code: '156930000',
    cp: [119.739693, 31.110794],
    distance: 150
  },
  {
    name: '浙江水泥',
    provinceList: ['浙江省', '福建省', '安徽省'],
    provinceCodeList: ['156330000', '156350000', '156340000'],
    pcode: '156100000',
    code: '156940000',
    cp: [120.327904, 30.128717],
    distance: 190
  },
  {
    name: '中南水泥',
    provinceList: ['湖南省', '广西壮族自治区', '广东省'],
    provinceCodeList: ['156430000', '156450000', '156440000'],
    pcode: '156100000',
    code: '156950000',
    cp: [112.986389, 28.244354],
    distance: 130
  },
  {
    name: '云南水泥',
    provinceList: ['云南省', '四川省'],
    provinceCodeList: ['156530000', '156510000'],
    pcode: '156100000',
    code: '156960000',
    cp: [102.831146, 24.888964],
    distance: 165

  },
  {
    name: '新疆水泥',
    provinceList: ['新疆维吾尔自治区'],
    provinceCodeList: ['156650000'],
    pcode: '156100000',
    code: '156970000',
    cp: [87.569954, 43.888718],
    distance: 120
  },
  {
    name: '江西水泥',
    provinceList: ['江西省', '安徽省'],
    provinceCodeList: ['156360000', '156340000'],
    pcode: '156100000',
    code: '156980000',
    cp: [115.881508, 28.701653],
    distance: 240
  },
  {
    name: '嘉华特水',
    provinceList: ['四川省'],
    provinceCodeList: ['156510000'],
    pcode: '156100000',
    code: '156990000',
    cp: [103.780846, 29.533480],
    distance: 120
  },
  {
    name: '贵州水泥',
    provinceList: ['贵州省'],
    provinceCodeList: ['156520000'],
    pcode: '156100000',
    code: '156991000',
    cp: [106.656685, 26.642223],
    distance: 130
  },
  {
    name: '西南水泥',
    provinceList: ['四川省', '重庆市', '陕西省'],
    provinceCodeList: ['156510000', '156500000', '156610000'],
    pcode: '156100000',
    code: '156992000',
    cp: [104.068062, 30.553680],
    distance: 140
  }
]
// 区域code下的省级code的map关系
const AREA_CODE_MAP = {}
// 区域code和名称的map关系
const AREA_NAME_MAP = {}
// 区域名称和区域渲染距离的map关系
const AREA_DISTANCE_MAP = {}
// 区域名称和code的map关系
const AREA_CODE_NAME_MAP = {}
// 区域code和中心点的map关系
const AREA_CP_MAP = {}
// 全部的省名称列表
let PROVINCE_LIST = []
// 全部的区域名称列表
const AREA_NAME_LIST = []

AREA_LIST.forEach(item => {
  AREA_CODE_MAP[item.code] = item.provinceCodeList
  AREA_CP_MAP[item.code] = item.cp
  AREA_NAME_MAP[item.code] = item.name
  PROVINCE_LIST = [...PROVINCE_LIST, ...item.provinceList]
  AREA_NAME_LIST.push(item.name)
  AREA_DISTANCE_MAP[item.name] = item.distance
  AREA_CODE_NAME_MAP[item.name] = item.code
})

export {
  AREA_LIST,
  AREA_CODE_MAP,
  AREA_NAME_MAP,
  AREA_JSON_MAP,
  HAI_NAN_JSON,
  PROVINCE_LIST,
  AREA_NAME_LIST,
  AREA_DISTANCE_MAP,
  AREA_CODE_NAME_MAP,
  AREA_CP_MAP
}
